import { render, staticRenderFns } from "./MainHome.vue?vue&type=template&id=3b76a0f2&"
import script from "./MainHome.vue?vue&type=script&lang=js&"
export * from "./MainHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports